import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { SelectedGuia } from "./types";

type Entity = SelectedGuia;
export interface Deps {
    onSeleccionar: (x: Entity, value: boolean) => void;
    onVer: (x: Entity) => void;
}
export function columnas(deps: Deps) {
    const ret: kea.Grid2Column<Entity>[] = [
        { title: "", key: "seleccionar", cell: x => ({ data: x.Selected, view: () => <kea.Checkbox value={x.Selected} onChange={sel => deps.onSeleccionar(x, sel)} /> }) },
        ...columnasFijas
    ];

    const rowStyleCol = kea.applyRowStyleToColumns(ret, (item: Entity) =>
        item.Selected ? { background: "#F7F7D4" } : {});
    return rowStyleCol;
}

export const columnasFijas: kea.Grid2Column<Entity>[] = [
    {
        title: "No. guia", cell: x => ({
            data: x.Folio, view: () =>
                <span style={{ fontFamily: "monospace" }} >
                    {x.Folio}
                    {
                        x.EsDeAcuse &&
                        <span className="label label-danger" >ACU</span>

                    }
                </span>
        })
    },
    { title: "Status", cell: x => ({ data: models.StatusGuia[x.Status] }) },
    { title: "Sucursal actual", cell: x => ({ data: x.Posicion }) },
    { title: "Fecha creación", cell: x => ({ data: kea.toDate(x.FechaCreacion) }) },
    { title: "Cliente origen", cell: x => ({ data: x.NombreClienteOrigen }) },
    { title: "Origen", cell: x => ({ data: x.DireccionOrigenDTO.Descripcion }) },
    { title: "Suc origen", cell: x => ({ data: x.NombreSucursalOrigen }) },
    { title: "Cliente destino", cell: x => ({ data: x.NombreClienteDestino }) },
    { title: "Destino", cell: x => ({ data: x.DireccionDestinoDTO.Descripcion }) },
    { title: "Suc destino", cell: x => ({ data: x.NombreSucursalDestino }) },
    { title: "Paquetes", cell: x => ({ data: (x.DescripcionPaquetesVolumen || "").split(", ") }) },
    { title: "Paquetes (detalle)", cell: x => ({ data: (x.DescripcionPaquetesTexto || "").split(", ") }) },
    { title: "Sobres", cell: x => ({ data: x.CantidadSobres }) },
    { title: "Distancia flete (km)", cell: x => ({ data: x.DistanciaFlete }) },
    { title: "Ruta de EAD", cell: x => ({ data: x.NombreRutaEntregaDomicilio }) },
    { title: "Flete por cobrar", cell: x => ({ data: x.FletePorCobrar }) },
    { title: "Pagada", cell: x => ({ data: x.Pagada }) },
    { title: "A crédito", cell: x => ({ data: x.EsDeCredito }) },
    { title: "Importe total", cell: x => ({ data: x.Importes ? x.Importes.Total : "", view: x.Importes ? kea.formatCurrency : undefined }) },
    { title: "Otros importes", cell: x => ({ data: x.Importes }) },
    { title: "Requiere contacto autorizado", cell: x => ({ data: x.RequiereContactoAutorizado }) },
    { title: "Contacto recibio", cell: x => ({ data: x.NombreContactoRecibio }) },
    { title: "Es de acuse", cell: x => ({ data: x.EsDeAcuse }) },
    { title: "Folio acuse original", cell: x => ({ data: x.FolioGuiaAcuse }) },
    { title: "Fecha de entrega", cell: x => ({ data: kea.toDate(x.FechaEntrega) }) },
    { title: "Usuario documentó", cell: x => ({ data: x.NombrePersonaDocumento }) },
    { title: "Usuario entregó", cell: x => ({ data: x.NombrePersonaEntrego }) },
    { title: "Tipo de seguro", cell: x => ({ data: nullsafe(x.TipoSeguro, x => models.TipoSeguroGuia[x]) }) },
    { title: "Valor declarado", cell: x => ({ data: x.ValorDeclarado }) },
    { title: "Motivo rechazo", cell: x => ({ data: x.MotivoRechazo }) },
    { title: "Fecha límite de facturación", cell: x => ({ data: kea.toDate(x.FechaLimiteFacturacion) }) },
    { title: "Tarifa", cell: x => ({ data: x.NombreTarifa }) },
    { title: "Observaciones", cell: x => ({ data: (x.ObservacionesGuia || "").split("|") }) },
]


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturaciononline/edit/components/columns.tsx